var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftOfficeOutlookLogoIcon1457211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.483,
    height: 54,
    viewBox: "0 0 58.483 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft_office_outlook_logo_icon_145721_1_",
    "data-name": "microsoft_office_outlook_logo_icon_145721 (1)",
    transform: "translate(0.4 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(15.367 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M73.39,13.111H34.2V6.868A1.838,1.838,0,0,1,36.023,5h35.5A1.848,1.848,0,0,1,73.39,6.868Z",
    transform: "translate(-34.2 -5)",
    fill: "#0464b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1788",
    "data-name": "Rectangle 1788",
    width: 13.078,
    height: 12.122,
    transform: "translate(0 8.111)",
    fill: "#0377d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    width: 13.078,
    height: 12.122,
    transform: "translate(13.078 8.111)",
    fill: "#29a7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1790",
    "data-name": "Rectangle 1790",
    width: 13.078,
    height: 12.122,
    transform: "translate(26.157 8.111)",
    fill: "#4fd8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 13.078,
    height: 12.122,
    transform: "translate(0 20.233)",
    fill: "#1681d7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 13.078,
    height: 12.122,
    transform: "translate(13.078 20.233)",
    fill: "#0178d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 13.078,
    height: 12.122,
    transform: "translate(26.157 20.233)",
    fill: "#29a7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    width: 13.078,
    height: 12.122,
    transform: "translate(13.078 32.309)",
    fill: "#0464b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    width: 13.078,
    height: 12.122,
    transform: "translate(26.157 32.309)",
    fill: "#1681d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M123.308,65.127,120.3,66.9V61.8l2.962,1.641A.964.964,0,0,1,123.308,65.127Z",
    transform: "translate(-65.697 -30.916)",
    fill: "#042071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M75.191,68.12l-.273.182h0l-.319.182L72.184,69.9v-.046L31.9,92.91H72.5a3.1,3.1,0,0,0,3.1-3.1L75.647,67.3A.873.873,0,0,1,75.191,68.12Z",
    transform: "translate(-17.581 -33.91)",
    fill: "#168fde"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490",
    transform: "translate(11.63 33.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M69.747,93.563H29.1a3.1,3.1,0,0,1-3.1-3.1V68.5Z",
    transform: "translate(-26 -68.5)",
    fill: "#29a7eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M26.668,61.12H2.516A2.937,2.937,0,0,1-.4,58.2V34.416A2.937,2.937,0,0,1,2.516,31.5H26.668a2.937,2.937,0,0,1,2.916,2.916V58.2A2.907,2.907,0,0,1,26.668,61.12Z",
    transform: "translate(0 -14.424)",
    fill: "#1681d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491",
    transform: "translate(6.937 23.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M23.356,62.761c-4.694,0-7.656-3.554-7.656-8.294,0-5.013,3.235-8.567,7.884-8.567,4.83,0,7.656,3.6,7.656,8.248.046,5.514-3.327,8.613-7.884,8.613Zm.182-2.37c2.916,0,4.557-2.689,4.557-6.106,0-3.1-1.549-5.97-4.557-5.97s-4.6,2.825-4.6,6.106,1.641,5.97,4.6,5.97Z",
    transform: "translate(-15.7 -45.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M44,37.3V61.361a2.937,2.937,0,0,1-2.916,2.916H26v2.6H43.5a2.937,2.937,0,0,0,2.916-2.916V40.171A2.862,2.862,0,0,0,44,37.3Z",
    transform: "translate(-14.37 -17.581)",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOfficeOutlookLogoIcon1457211);
export default __webpack_public_path__ + "static/media/microsoft_office_outlook_logo_icon_145721 (1).d038da3a229498808079b624b64ea52c.svg";
export { ForwardRef as ReactComponent };